import React from 'react';
import PageContainerWithLogo from '../Core/PageContainerWithLogo';
import '../../css/about.css';

const About = () =>
{
  // Array of tile images for decoration
  const decorativeTiles = [
    'tile_base_1.png',
    'tile_base_7.png',
    'tile_base_12.png',
    'tile_base_17.png',
    'tile_base_22.png',
    'tile_base_3.png',
    'tile_base_14.png',
    'tile_base_19.png',
    'tile_base_24.png'
  ];

  return (
    <PageContainerWithLogo>
      <div className="about-container">
        <header className="about-header">
          <h1>About Tilefolk.io
          </h1>
          <p>Bringing a classic board game to the digital world</p>
        </header>

        <div className="about-content">
          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 0 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(15deg)' } }
                onError={ ( e ) =>
                {
                  console.warn( `Failed to load decorative tile: ${decorativeTiles[ 0 ]}` );
                  e.target.style.display = 'none'; // Hide broken image
                } }
              />
            </div>
            <div className="about-section-text">
              <h2>What is Tilefolk.io?</h2>
              <p>
                Tilefolk.io is a free online platform dedicated to bringing the beloved tile-laying board game
                Carcassonne to digital life. Our mission is to provide an authentic, high-quality gaming
                experience that captures the strategy and social interaction of the original board game while
                making it accessible to players worldwide.
              </p>
              <p>
                Whether you're a seasoned Carcassonne veteran or new to tile-laying games, our platform
                offers an intuitive interface, real-time multiplayer gameplay, and features designed to
                enhance your gaming experience while staying true to the classic gameplay mechanics.
              </p>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 1 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(-12deg)' } }
              />
            </div>
            <div className="about-section-text">
              <h2>About the Creator</h2>
              <p>
                Hi! I'm Tom Figg, a passionate game developer and board game enthusiast based in London, UK.
                I created Tilefolk.io because I wanted to share my love for Carcassonne with a broader community
                and provide a platform where players could enjoy this fantastic game anytime, anywhere.
              </p>
              <p>
                With a background in mobile games development in Unity, I've
                spent the last 4 years teaching myself some new web-development and server tech skills to bring Tilefolk.io to life.
                My goal has always been to create a faithful digital adaptation that respects the original game while adding modern conveniences
                like online multiplayer, spectator modes, and social features.
              </p>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 2 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(8deg)' } }
              />
            </div>
            <div className="about-section-text">
              <h2>Our Commitment to Quality</h2>
              <p>
                At Tilefolk.io, we're committed to providing:
              </p>
              <ul>
                <li><strong>Authentic Gameplay:</strong> Faithful recreation of Carcassonne's rules and mechanics</li>
                <li><strong>Fair Play:</strong> Anti-cheat systems and karma scoring to maintain game integrity</li>
                <li><strong>Privacy Protection:</strong> Responsible handling of user data (see our Privacy Policy)</li>
                <li><strong>Community Building:</strong> Tools and features that foster positive player interactions</li>
                <li><strong>Continuous Improvement:</strong> Regular updates based on community feedback</li>
              </ul>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 3 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(-18deg)' } }
              />
            </div>
            <div className="about-section-text">
              <h2>Development & Launch</h2>
              <p>
                Development of Tilefolk.io began in late 2021 with the goal of creating the most authentic
                online Carcassonne experience available. After months of development, testing, and community
                feedback, we launched the public beta in December 2025.
              </p>
              <p>
                The game is built using modern web technologies including React, PixiJS, Node.js, and WebSocket
                connections for real-time gameplay.
              </p>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 4 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(22deg)' } }
              />
            </div>
            <div className="about-section-text">
              <h2>Legal & Copyright</h2>
              <p>
                Tilefolk.io operates under the principle that game mechanics cannot be copyrighted. We have
                developed all of our own artwork, code, and digital assets. Our implementation respects
                intellectual property rights while providing our own unique take on the tile-laying genre.
              </p>
              <p>
                All original content, including our custom artwork, user interface design, and codebase,
                is owned by Inkcap Games Ltd and protected under applicable copyright laws.
              </p>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 5 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(-10deg)' } }
              />
            </div>
            <div className="about-section-text">
              <h2>Revenue & Sustainability</h2>
              <p>
                Tilefolk.io is currently operated as a passion project with the goal of covering hosting
                and development costs while keeping the core game free for all players. We may introduce
                optional premium features or display advertising in the future to support ongoing development
                and server costs.
              </p>
              <p>
                Any revenue generated will be reinvested into improving the platform, adding new features,
                and ensuring reliable service for our growing community of players.
              </p>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 6 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(16deg)' } }
              />
            </div>
            <div className="about-section-text">
              <h2>Community & Feedback</h2>
              <p>
                Our community is at the heart of everything we do. We actively listen to player feedback
                and regularly implement improvements based on user suggestions. Join our Discord community
                to connect with other players, share strategies, and help shape the future of Tilefolk.io.
              </p>
              <p>
                We believe in transparency and open communication. If you have questions, suggestions, or
                concerns, please don't hesitate to reach out through our contact channels.
              </p>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 7 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(-7deg)' } }
              />
            </div>
            <div className="about-section-text">
              <h2>Contact Information</h2>
              <div className="contact-info">
                <p><strong>Email:</strong> <a href="mailto:help@tilefolk.io">help@tilefolk.io</a></p>
                <p><strong>Discord:</strong> <a href="https://discord.gg/9qg5E8fCQQ" target="_blank" rel="noopener noreferrer">Join our community</a></p>
                <p><strong>Location:</strong> London, UK</p>
                <p><strong>Developer:</strong> Tom Figg</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-tile">
              <img
                src={ `${process.env.PUBLIC_URL}/tiles/v2/${decorativeTiles[ 8 ]}` }
                alt="Decorative tile"
                className="decorative-tile"
                style={ { transform: 'rotate(25deg)' } }
              />
            </div>
            <div className="about-section-text">
              <h2>Acknowledgments</h2>
              <p>
                Special thanks to all our beta testers, community members, and everyone who has provided
                feedback to help make <b>tilefolk.io</b> even better. This project wouldn't be possible without the
                support of the board gaming community and the original creators of tile-laying games who
                inspired this digital adaptation.
              </p>
            </div>
          </section>
        </div>
      </div>
    </PageContainerWithLogo>
  );
};

export default About;
